<template>
  <v-container>
    <div>
      <v-btn
        v-for="league in leagues"
        :key="league + '-import'"
        :color="chosen_league == league ? 'primary' : ''"
        @click="chosen_league = league"
        outlined
        class="ml-2"
      >
        {{ league }}
      </v-btn>
    </div>
    <ImportLeagueGames
      v-if="chosen_league"
      :league="chosen_league"
      :key="chosen_league"
    ></ImportLeagueGames>
  </v-container>
</template>

<script>
import ImportLeagueGames from '@/components/tiimi_admin/import/ImportLeagueGames.vue';

export default {
  components: { ImportLeagueGames },
  data: () => ({
    leagues: ['msu', 'nsu', 'myp'],
    chosen_league: null
  })
}
</script>